const paginationDefault = {
  page: 1,
  limit: 20,
};

export default paginationDefault;
